import React from "react";

export default function DocumentsSkeleton() {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950"
        >
          <div className="aspect-[16/10] animate-pulse bg-slate-200 dark:bg-slate-800" />

          <div className="space-y-4 p-5">
            <div className="h-4 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-7 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-5 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

            <div className="flex gap-2 pt-3">
              <div className="h-11 w-28 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="h-11 w-32 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}